<script>
export default {
    name: "AuthWelcome",
    props: {
        title: {
            type: String,
            required: false
        },
        description: {
            type: String,
            required: false
        }
    }
}
</script>

<template>
    <div class="welcome-card-illustration d-none d-lg-flex flex-column w-100 p-5">
        <img alt="Logo" src="/img/logo.svg" width="300">
        <h3 class="mt-5" v-if="title">{{ title }}</h3>
        <p v-if="description">{{ description }}</p>
    </div>
</template>
